import React from 'react';
import { Link } from 'react-router-dom';
import Security from './Security';
import Modal from '../../components/Modal';

import imgCamera from '../../assets/images/camera.svg';

function SecurityCameraAccess() {
  return (
    <div>
      <Security />
      <Modal>
        <div className="card-content error-modal">
          <img src={imgCamera} alt="" />
          <p>To upload a photo ID you’ll need to allow your browser to access your camera.</p>
          <Link to="/" className="btn">Allow Camera Access</Link>
        </div>
        {// eslint-disable-next-line jsx-a11y/control-has-associated-label
          <button type="button" className="close" />
        }
      </Modal>
    </div>
  );
}

export default SecurityCameraAccess;
